import { Box, Button, Link, Typography } from "@mui/material";
import { ContentContainer } from "./ContentContainer";
import { SubSectionHeader } from "./SubSectionHeader";
import { Tag } from "./ExperienceModal";
import PouchLogo from "../asset/PouchLogo.png";
import PocketLogo from "../asset/PocketLogo.png";
import TempysLogo from "../asset/TempysLogo.png";

type ProjectType = {
  title: string;
  description: React.ReactElement;
  languages: string[];
  date: string;
  logo: string;
  color: string;
  link?: string;
};

const projects: ProjectType[] = [
  {
    title: "Pocket",
    description: (
      <>
        Everytime I learn something new from work, I add it back to Pocket. The
        aim of pocket is to build a prepayment solution for beauty and lifestyle
        retailers. The product is coming together slowly. It will be a while
        till I actually launch something. Pocket to me is a learning experience
        and a practice ground for the skills I learned from work!
      </>
    ),
    languages: ["React JS", "Typescript", "AWS", "Stripe API", "Terraform"],
    date: "🚧 Still developing",
    logo: PocketLogo,
    color: "#623494",
  },
  {
    title: "Pouch Loyalty",
    description: (
      <>
        Pouch is a project I worked on while I was studying at university. I was
        inspired to build a mobile application to help local restaurants and
        cafe store their loyalty points digitally. We've launched with 3
        businesses and over 1000 accounts created to date. Nevertheless, life
        got busy after I started working full time and so I do not have time to
        continue working on the project actively.
        <br />
        <br />
        🏆 Google Generation Scholarship 2022
        <br />
        🏆 Macquarie Engineering Award, Coding Fest 2022
      </>
    ),
    languages: [
      "React JS",
      "Firebase",
      "App Store",
      "Google PlayStore",
      "Expo",
    ],
    date: "2021 - 2023",
    logo: PouchLogo,
    color: "#F26D61",
    link: "https://www.pouchloyalty.com/",
  },
  {
    title: "Tempys",
    description: (
      <>
        I wanted to experiment with neumorphism and explore its application in
        UI design. My goal is to create a visually appealing interface with soft
        shadows, subtle highlights, and a minimalist aesthetic. One limitation
        of web apps is that users cannot physically feel the elements they
        interact with. Therefore, I aim to replicate that tactile sensation
        through depth, lighting, and shadow effects on a laptop or mobile
        screen.
      </>
    ),
    languages: [
      "Neumorphism",
      "Design Experiment",
      "React JS",
      "CSS",
      "Amplify",
    ],
    date: "2022",
    logo: TempysLogo,
    color: "#51538A",
    link: "https://main.d3tfcn4k8oxllc.amplifyapp.com/loginNew",
  },
];

export const Projects = () => {
  return (
    <ContentContainer id="projects">
      <div style={{ textAlign: "left" }}>
        <SubSectionHeader
          title="Personal Projects"
          subtitle="Frameworks I've experimented with"
        />
        {projects.map((project) => (
          <Box
            sx={{
              marginTop: 2,
              display: "flex",
              flex: 1,
              width: "100%",
              marginY: 4,
              flexDirection: { xs: "column", md: "row" },
              rowGap: { xs: 2, md: 0 },
            }}
          >
            <a href={project.link} target="_blank" rel="noreferrer">
              <img
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "100%",
                  textAlign: "center",
                }}
                src={project.logo}
              />
            </a>
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                paddingLeft: 24,
                rowGap: 10,
              }}
            >
              <Typography variant="body1" component="div" fontWeight={700}>
                {project.title}
              </Typography>
              <Typography variant="overline" component="div" fontWeight={700}>
                {project.date}
              </Typography>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  columnGap: 8,
                  flexWrap: "wrap",
                  rowGap: 8,
                }}
              >
                {project.languages.map((item, index) => (
                  <Tag text={item} bgColor={project.color} />
                ))}
              </div>
              <Typography variant="body1">{project.description}</Typography>
            </div>
          </Box>
        ))}
      </div>
    </ContentContainer>
  );
};
